import { ReactNode } from 'react';

import { Bean } from '@dreryk/react-common';
import { EmptyStatePlaceholder, InteractiveTable } from '@dreryk/react-components';

import { translationKeys } from '../../../../translations';
import { GroupSessionsFormController } from '../../GroupSessionsForm.types';
import { GroupSessionsPractitionerValue } from '../GroupSessionsPractitionersField.types';

import { GroupSessionsPractitionersInteractiveTableSelector } from './GroupSessionsPractitionersInteractiveTableSelector';
import { useGroupSessionsPractitionersInteractiveTableColumnConfigurationOptions } from './GroupSessionsPractitionersInteractiveTable.hooks';

type GroupSessionsPractitionersInteractiveTableProps = Pick<GroupSessionsFormController, 'register'> & {
   readonly header: ReactNode;
};

export const GroupSessionsPractitionersInteractiveTable = (
   props: GroupSessionsPractitionersInteractiveTableProps
): JSX.Element => {
   const columns = useGroupSessionsPractitionersInteractiveTableColumnConfigurationOptions();

   return (
      <InteractiveTable<GroupSessionsPractitionerValue, Bean>
         name={'practitioners.value'}
         register={props.register}
         columns={columns}
         testId={'practitioners'}
         header={props.header}
         placeholder={<EmptyStatePlaceholder heading={translationKeys.noPractitioners} testId={'noPractitioners'} />}
      />
   );
};

GroupSessionsPractitionersInteractiveTable.Selector = GroupSessionsPractitionersInteractiveTableSelector;
